import React from "react";
import RefereeInformationCard from "../information_cards/RefereeInformationCard";
import PersonalDetailsCard from "../information_cards/PersonalDetailsCard";
import AcademicDetailsSiwes from "../information_cards/AcademicDetailsSiwes";
import AcademicDetailsIT from "../information_cards/AcademicDetailsIT";
import AcademicDetailsNDE from "../information_cards/AcademicDetailsNDE";
import DocumentUpload from "../information_cards/DocumentUpload";
import FinalAssessmentMail from "../information_cards/mailsend";
import CommentsCard from "../information_cards/CommentsCard";
import {
  useGetAllinformationByid,
  useGetAcceptedbycode,
} from "../../adapters/Requests";
import { internshipTypes } from "../../utils/constants";
import { Loader2 } from "lucide-react";

export default function AcceptanceDetailsViewer({
  applicationId,
  internshipType,
  onActionComplete,
}) {
  let componentToRender;

  const { data, error, isLoading } = useGetAllinformationByid({
    application_id: applicationId,
  });
  const vacancy_code = data?.vacancy?.id;

  const { data: acceptedData } = useGetAcceptedbycode(vacancy_code || "", {
    enabled: !!vacancy_code,
  });

  if (isLoading) {
    return (
      <div className="flex justify-center items-center p-10 h-full">
        <Loader2 className="animate-spin text-green-600" size={32} />
      </div>
    );
  }

  if (error) {
    return <div className="p-4 text-red-500">Error: {error.message}</div>;
  }

  switch (internshipType?.toLowerCase()) {
    case "it":
      componentToRender = (
        <AcademicDetailsIT details={data?.ApplicationsAcademicQualification} />
      );
      break;
    case "siwes":
      componentToRender = (
        <AcademicDetailsSiwes
          details={data?.ApplicationsAcademicQualification}
        />
      );
      break;
    case "gap":
      componentToRender = (
        <AcademicDetailsNDE details={data?.ApplicationNYSCDetails} />
      );
      break;
    default:
      componentToRender = <></>;
  }

  const remaining = data?.vacancy?.quota - (acceptedData?.count || 0);

  const applicantSelectedCourse =
    data?.ApplicationsAcademicQualification?.course;

  const selectedVacancyCourse = data?.vacancy?.vacancyCourses?.find(
    (course) => {
      if (course && applicantSelectedCourse) {
        return (
          course?.id == applicantSelectedCourse?.id ||
          course?.courseId == applicantSelectedCourse?.id
        );
      }
      return false;
    }
  );

  const isSiwes =
    data?.vacancy?.vacancy_position?.name === internshipTypes.SIWES;

  const siwesCourseQuota = Number(selectedVacancyCourse?.quota || 0);
  const siwesCoursedUsedSlots = Number(selectedVacancyCourse?.accepted || 0);

  return (
    <div className="space-y-5 pb-6 h-full overflow-y-auto px-1">
      <div className="flex items-center justify-between mb-2">
        <h2 className="text-xl font-semibold text-gray-900">
          Acceptance
        </h2>
      </div>

      <div className="space-y-5">
        <div className="flex flex-col gap-2 text-xs mt-2 p-3 bg-gray-50 border border-green-200 rounded-md">
          <div className="grid grid-cols-2 gap-4">
            <div>
              <div className="text-gray-500">Internship Type</div>
              <div className="font-semibold text-gray-900">
                {data?.vacancy?.vacancy_position?.name?.toUpperCase()}
              </div>
            </div>
            <div>
              <div className="text-gray-500">Location</div>
              <div className="font-semibold text-gray-900">
                {data?.vacancy?.business_unit?.name},{" "}
                {data?.vacancy?.location?.name}
              </div>
            </div>
            <div>
              <div className="text-gray-500">Total Quota</div>
              <div className="font-semibold text-gray-900">
                {data?.vacancy?.quota}
              </div>
            </div>
            <div>
              <div className="text-gray-500">Remaining Quota</div>
              <div className="font-semibold text-green-700">{remaining}</div>
            </div>
          </div>

          {isSiwes && (
            <div className="mt-2 pt-2 border-t border-gray-200 grid grid-cols-2 gap-4">
              <div>
                <div className="text-gray-500">Selected Course</div>
                <div className="font-semibold text-gray-900">
                  {applicantSelectedCourse?.name}
                </div>
              </div>
              <div>
                <div className="text-gray-500">Course Remaining</div>
                <div className="font-semibold text-green-700">
                  {siwesCourseQuota - siwesCoursedUsedSlots}
                </div>
              </div>
            </div>
          )}
        </div>

        {remaining <= 0 ? (
          <div className="bg-red-50 border border-red-200 rounded-lg p-6 text-center">
            <div className="font-bold text-red-600 text-lg">
              Quota met for this vacancy
            </div>
            <p className="text-sm text-red-500 mt-1">
              You cannot accept more applicants for this position.
            </p>
          </div>
        ) : (
          <>
            <FinalAssessmentMail
              isSiwes={isSiwes}
              siwesCourseQuota={siwesCourseQuota}
              siwesCoursedUsedSlots={siwesCoursedUsedSlots}
              applicationId={applicationId}
              onActionComplete={onActionComplete}
            />
            {data?.Comments?.length > 0 && (
              <CommentsCard comments={data?.Comments} />
            )}
            <div className="flex flex-col gap-5">
              <div>
                <div className="mb-5">
                  <PersonalDetailsCard
                    applicant={data?.Applicant}
                    nextOfKins={data?.ApplicationNextOfKins}
                  />
                  <DocumentUpload
                    documents={data?.ApplicationDocuments}
                    vacancy={vacancy_code}
                  />
                </div>
              </div>
              <div className="space-y-5">
                {componentToRender}
                {!(internshipType?.toLowerCase() === "siwes") ? (
                  <RefereeInformationCard
                    referees={data?.ApplicationReferees}
                  />
                ) : (
                  <></>
                )}
              </div>
            </div>
          </>
        )}
      </div>
    </div>
  );
}
